import {
    FC,
    ExtendProps,
    CanBeSignal,
    ContainerProps,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Container} from '../Container';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import {createSpineInstance, setAnimation, setUpdater, replaceSlots, handlePlayProp} from './etc';
import {SpineComponentBase} from './SpineComponentBase';
import {IAnimationStateListener} from 'pixi-spine';

// TODO: why not just use {AnimationProperty} from '@gongxigames/framework/core/fragments/display';
export type Animation = {
    name: string;
    trackIndex?: number;
    loop?: boolean;
    listeners?: IAnimationStateListener;
    skin?: string;
};

export type SpineComponentBaseProps = {
    spine: CanBeSignal<string>;
    updater?: CanBeSignal<UpdateManager>;
    animation?: CanBeSignal<Animation>;
    play?: CanBeSignal<boolean>;
};

export type SpineProps = SpineComponentBaseProps & ExtendProps<{}, ContainerProps, SpineComponentBase>;

export const $Spine: FC<SpineProps> = (props) => {
    const instance = props.instance ??= createSpineInstance(props);
    const {children = [], ...spineProps} = props;

    setUpdater(props, instance);

    if (props.animation) {
        setAnimation(props, instance);
    }

    handlePlayProp(props, instance);

    $Container(spineProps as ContainerProps);

    replaceSlots(instance, children);

    return instance;
};
